module.exports = __webpack_public_path__ + "03_glasses_red.ff2edff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer4/03_glasses_red.png
// module id = DTq/
// module chunks = 0